import { call, put } from 'redux-saga/effects';
import { apiGeneral, notify } from 'services';
import jsCookie from 'js-cookie';
import { requestErrorHandler, expirationDaysText } from 'utils';
import { AuthActions, LoginRequest } from 'store/ducks/auth';

interface ICookie {
  webcolToken: string | null;
  comexToken: string | null;
}
export const authRehydrateAccessToken = ({ payload }: Record<string, any>) => {
  if (!payload?.auth?.data) return;
  const { accessToken } = payload.auth.data;
  if (accessToken) {
    apiGeneral.defaults.headers.Authorization = `Bearer ${accessToken}`;
  }
};

export function* authFirebaseLoginRequest(action: any) {
  try {
    const { data: responseData } = yield call(
      apiGeneral.post,
      'firebase-login',
      action.data
    );

    yield handleLoginSuccess(responseData);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(AuthActions.loginFailure(errorMessage));
  }
}

export function* authLoginRequest(action: any) {
  try {
    const { data: postData } = action as LoginRequest;
    const { data: responseData } = yield call(
      apiGeneral.post,
      'login',
      postData
    );

    yield handleLoginSuccess(responseData);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(AuthActions.loginFailure(errorMessage));
  }
}

export function* authLogoutRequest() {
  try {
    yield call(apiGeneral.post, 'logout');
  } catch (error) {
    yield;
  } finally {
    jsCookie.remove('_iconic');
    notify('success', 'Até mais');
    yield put(AuthActions.logoutSuccess());
    apiGeneral.defaults.headers.Authorization = null;
  }
}

function* handleLoginSuccess(responseData: any) {
  const { token: accessToken, comexToken, ...data } = responseData;

  apiGeneral.defaults.headers.Authorization = `Bearer ${accessToken}`;

  const tokensObj = { webcolToken: accessToken, comexToken: comexToken };

  const cookieToken = encodeURIComponent(
    JSON.stringify(tokensObj).replace(/[\n\t]/g, '')
  );

  yield jsCookie.set('_iconic', cookieToken, {
    path: '/',
    domain:
      process.env.NODE_ENV !== 'production' ? 'localhost' : '.webcol.systems',
  });

  const myJsCookie = jsCookie.get('_iconic') || JSON.stringify({});

  const cookie = JSON.parse(decodeURIComponent(myJsCookie)) as ICookie;

  console.log('cookie', cookie);

  if (!cookie?.comexToken) {
    // notify('warning', 'Login Comex não realizado.');
  }
  if (data.integration) {
    throw new Error('Usuário integração: Acesso não autorizado');
  }

  yield put(AuthActions.loginSuccess({ ...data, accessToken }));
  notify('success', `Bem-vindo ${data.name}`);

  const { days_left_password }: { days_left_password: null | number } = data;

  if (days_left_password === null) {
    return;
  } else if (days_left_password <= 0) {
    return notify('error', `Sua senha expirou!`);
  } else if (days_left_password <= 10) {
    return notify('warning', expirationDaysText(days_left_password));
  }
}
